module.exports = __webpack_public_path__ + "static/sider-whitepaper-e31f0d02e005ed3cb15315424491b9a6.png";